import TextField from '@components/v2/form/TextField/TextField';
import { useCallback } from 'react';
import LangEnum from '../../../../../../lang/LangEnum';
import snackbarStore from '../../../../../../stores/Snackbar.store';
import { onlyNumbers } from '../../../../../../utils/validators';
import { useTranslation } from '../../../../../translation/TranslationContext';
import { HandleChangeParams } from '../../../../types/generalSettingsPage.types';

interface SelloutLastDaysInputProps {
  selloutPeriodLastDaysInterval: number;
  handleChange: ({ value, name }: HandleChangeParams) => Promise<void>;
  handleBlur: () => void;
}

export const SelloutLastDaysInput = ({
  selloutPeriodLastDaysInterval,
  handleChange,
  handleBlur,
}: SelloutLastDaysInputProps) => {
  const { translate } = useTranslation();
  const { handleMessage } = snackbarStore;

  const hasError = useCallback(
    (value?: number): boolean => !!value && (value < 0 || value > 365),
    [],
  );

  const lastDaysError = hasError(selloutPeriodLastDaysInterval)
    ? translate(LangEnum.SELLOUT_GENERAL_SETTINGS_SELLOUT_REFERENCE_PERIOD_ERROR)
    : undefined;

  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const stringOnlyWithNumbers = onlyNumbers(event.target.value);
    const value = Number(stringOnlyWithNumbers);

    if (hasError(value)) {
      handleMessage({
        message: translate(LangEnum.SELLOUT_GENERAL_SETTINGS_SELLOUT_REFERENCE_PERIOD_ERROR) || '',
        type: 'error',
      });
      return;
    }

    handleChange({
      name: 'selloutPeriodLastDaysInterval',
      value,
    });
  };

  return (
    <div>
      <TextField
        type="number"
        name="selloutPeriodLastDaysInterval"
        value={selloutPeriodLastDaysInterval || ''}
        error={!!lastDaysError}
        helperText={lastDaysError}
        onChange={onChange}
        onBlur={() => handleBlur()}
        label={translate(
          LangEnum.SELLOUT_GENERAL_SETTINGS_SELLOUT_PERIOD_SELECT_LAST_DAYS_OPTIONS_TITLE,
        )}
        slotProps={{
          htmlInput: {
            min: 0,
            max: 365,
            inputMode: 'numeric',
            pattern: '[0-9]*',
          },
        }}
      />
    </div>
  );
};
